export const CollectionListTranslations = {
    collectionListTranslations: {
        pageTitle: 'Colecciones',
        description: 'Explore nuestras colecciones de artículos de expertos, seminarios web y más.',
    }
}